'use client';

import React from 'react';

const diffs = [
  {
    n: '01',
    title: 'Agent-First Architecture',
    body: 'Every feature is built as an agent first, UI second. The UI is for supervision, not execution. Competitors built UIs first and are retrofitting agents behind them.',
  },
  {
    n: '02',
    title: 'Unified Data Graph',
    body: 'Leases, tenants, units, payments, work orders, and sensors live in one semantic graph — so any agent can reason across domains. Competitors have 10+ DBs with sync issues.',
  },
  {
    n: '03',
    title: 'Open LLM Layer',
    body: 'Customers bring their own LLM via MCP. No vendor lock-in. AppFolio uses only Amazon Nova. Yardi added Claude recently but is tied to its stack.',
  },
  {
    n: '04',
    title: 'Autonomous Workflows by Default',
    body: 'Every task has an "autopilot" toggle. Turn it on, the agent runs. Turn it off, it suggests. Competitors\' AI is an "assistant" — humans still drive every step.',
  },
  {
    n: '05',
    title: 'Community-Built Agent Marketplace',
    body: 'Third parties — accountants, brokers, attorneys, regulation experts — publish certified agents. POPIA compliance. Dubai VAT. UK Section 21. Competitors are US-centric.',
  },
];

export default function AIDifferentiators() {
  return (
    <section className="py-24 px-6 relative">
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            'radial-gradient(ellipse 60% 50% at 50% 50%, rgba(124,58,237,0.12) 0%, transparent 70%)',
        }}
      />
      <div className="relative max-w-6xl mx-auto">
        <div className="reveal-blur mb-12 text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-[rgba(124,58,237,0.25)] mb-5">
            <span className="text-[10px] font-mono text-[#A78BFA] tracking-widest uppercase">
              The Differentiator
            </span>
          </div>
          <h2
            className="font-manrope font-extrabold tracking-tighter text-[#EEEEF0]"
            style={{ fontSize: 'clamp(1.75rem, 4vw, 3rem)' }}
          >
            Five advantages competitors
            <br />
            <span
              style={{
                background: 'linear-gradient(135deg, #7C3AED, #A78BFA)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              can&apos;t replicate without rebuilding.
            </span>
          </h2>
          <p className="mt-4 text-[#9999A8] max-w-2xl mx-auto">
            MRI, Yardi, and AppFolio are bolting AI onto software built in the 1990s–2000s. Propmatic is AI-native from day one.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 stagger-children">
          {diffs.map((d, i) => (
            <div
              key={d.n}
              className={`reveal-blur bento-card card-shine p-7 relative overflow-hidden ${
                i === 0 ? 'lg:col-span-2' : ''
              }`}
            >
              {/* Giant number backdrop */}
              <div
                className="absolute -right-4 -top-4 font-manrope font-extrabold text-[120px] leading-none tracking-tighter pointer-events-none select-none"
                style={{
                  background: 'linear-gradient(180deg, rgba(124,58,237,0.15), rgba(124,58,237,0))',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                }}
              >
                {d.n}
              </div>
              <div className="relative z-10">
                <div className="text-[10px] font-mono text-[#A78BFA] tracking-widest uppercase">
                  Edge {d.n}
                </div>
                <h3 className="font-manrope font-extrabold text-xl md:text-2xl text-[#EEEEF0] tracking-tight mt-2">
                  {d.title}
                </h3>
                <p className="text-sm text-[#9999A8] mt-3 leading-relaxed">{d.body}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
